// import React, { useState, useEffect } from 'react'
// import { Table, Form, Button, Row, Col } from 'react-bootstrap'
// import { LinkContainer } from 'react-router-bootstrap'
// import { useDispatch, useSelector } from 'react-redux'
// import Message from '../components/Message'
// import Loader from '../components/Loader'
// import { getUserDetails, updateUserProfile } from '../actions/userActions'
// import { listMyOrders } from '../actions/orderActions'
// import { USER_UPDATE_PROFILE_RESET } from '../constants/userConstants'

// const ProfileScreen = ({ location, history }) => {
//   const [firstName, setFirstName] = useState('')
//   const [lastName, setLastName] = useState('')
//   const [username, setUsername] = useState('')
//   const [email, setEmail] = useState('')
//   const [password, setPassword] = useState('')
//   const [confirmPassword, setConfirmPassword] = useState('')
//   const [message, setMessage] = useState(null)

//   const dispatch = useDispatch()

//   const userDetails = useSelector((state) => state.userDetails)
//   const { loading, error, user } = userDetails

//   const userLogin = useSelector((state) => state.userLogin)
//   const { userInfo } = userLogin

//   const userUpdateProfile = useSelector((state) => state.userUpdateProfile)
//   const { success } = userUpdateProfile

//   const orderListMy = useSelector((state) => state.orderListMy)
//   const { loading: loadingOrders, error: errorOrders, orders } = orderListMy

//   useEffect(() => {
//     if (!userInfo) {
//       history.push('/login')
//     } else {
//       if (!user || !user.firstName || !user.lastName || !user.username || success) {
//         dispatch({ type: USER_UPDATE_PROFILE_RESET })
//         dispatch(getUserDetails('profile'))
//         dispatch(listMyOrders())
//       } else {
//         setFirstName(user.firstName)
//         setLastName(user.lastName)
//         setUsername(user.username)
//         setEmail(user.email)
//       }
//     }
//   }, [dispatch, history, userInfo, user, success])

//   const submitHandler = (e) => {
//     e.preventDefault()
//     if (password !== confirmPassword) {
//       setMessage('Passwords do not match')
//     } else {
//       dispatch(updateUserProfile({ id: user._id, firstName, lastName, email, password }))
//     }
//   }

//   return (
//     <Row>
//       <Col md={3}>
//         <h2>User Profile</h2>
//         <h4>Username: {username}</h4>
//         {message && <Message variant='danger'>{message}</Message>}
//         {}
//         {success && <Message variant='success'>Profile Updated</Message>}
//         {loading ? (
//           <Loader />
//         ) : error ? (
//           <Message variant='danger'>{error}</Message>
//         ) : (

//           <Form onSubmit={submitHandler}>
//             <Form.Group controlId='firstName'>
//               <Form.Label>First Name</Form.Label>
//               <Form.Control
//                 type='firstName'
//                 placeholder='Enter first name'
//                 value={firstName}
//                 onChange={(e) => setFirstName(e.target.value)}
//               ></Form.Control>
//             </Form.Group>

//             <Form.Group controlId='LastName'>
//               <Form.Label>Last Name</Form.Label>
//               <Form.Control
//                 type='lastName'
//                 placeholder='Enter last name'
//                 value={lastName}
//                 onChange={(e) => setLastName(e.target.value)}
//               ></Form.Control>
//             </Form.Group>

//             <Form.Group controlId='email'>
//               <Form.Label>Email Address</Form.Label>
//               <Form.Control
//                 type='email'
//                 placeholder='Enter email'
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//               ></Form.Control>
//             </Form.Group>

//             <Form.Group controlId='password'>
//               <Form.Label>Password</Form.Label>
//               <Form.Control
//                 type='password'
//                 placeholder='Enter password'
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//               ></Form.Control>
//             </Form.Group>

//             <Form.Group controlId='confirmPassword'>
//               <Form.Label>Confirm Password</Form.Label>
//               <Form.Control
//                 type='password'
//                 placeholder='Confirm password'
//                 value={confirmPassword}
//                 onChange={(e) => setConfirmPassword(e.target.value)}
//               ></Form.Control>
//             </Form.Group>

//             <Button type='submit' variant='primary'>
//               Update
//             </Button>
//           </Form>
//         )}
//       </Col>
//       <Col md={9}>
//         <h2>My Orders</h2>
//         {loadingOrders ? (
//           <Loader />
//         ) : errorOrders ? (
//           <Message variant='danger'>{errorOrders}</Message>
//         ) : (
//           <Table striped bordered hover responsive className='table-sm'>
//             <thead>
//               <tr>
//                 <th>ID</th>
//                 <th>DATE</th>
//                 <th>TOTAL</th>
//                 <th>PAID</th>
//                 <th>SHIPPED</th>
//                 <th>DELIVERED</th>
//                 <th></th>
//               </tr>
//             </thead>
//             <tbody>
//               {orders.map((order) => (
//                 <tr key={order._id}>
//                   <td>{order._id}</td>
//                   <td>{order.createdAt.substring(0, 10)}</td>
//                   <td>{order.totalPrice}</td>
//                   <td>
//                     {order.isPaid ? (
//                       order.paidAt.substring(0, 10)
//                     ) : (
//                       <i className='fas fa-times' style={{ color: 'red' }}></i>
//                     )}
//                   </td>
//                   <td>
//                     {order.isShipped ? (
//                       order.shippedAt.substring(0, 10)
//                     ) : (
//                       <i className='fas fa-times' style={{ color: 'red' }}></i>
//                     )}
//                   </td>
//                   <td>
//                     {order.isDelivered ? (
//                       order.deliveredAt.substring(0, 10)
//                     ) : (
//                       <i className='fas fa-times' style={{ color: 'red' }}></i>
//                     )}
//                   </td>
//                   <td>
//                     <LinkContainer to={`/order/${order._id}`}>
//                       <Button className='btn-sm' variant='light'>
//                         Details
//                       </Button>
//                     </LinkContainer>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </Table>
//         )}
//       </Col>
//     </Row>
//   )
// }

// export default ProfileScreen


import React, { useState, useEffect, useRef } from 'react'
import { Table, Form, Button, Row, Col, Toast } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import Message from '../components/Message'
import Loader from '../components/Loader'
import Meta from '../components/Meta'
import StepUpPasswordModal from '../components/StepUpPasswordModal'
import { requestStepUpToken } from '../utils/stepUp'
import { getUserDetails, updateUserProfile, updateUserPassword, resetPasswordUpdate } from '../slices/userSlice'
import { listMyOrders } from '../slices/orderSlice'
import { USER_UPDATE_PROFILE_RESET } from '../constants/userConstants'
import ReCAPTCHA from 'react-google-recaptcha'
import AddressManager from '../components/AddressManager'
import PasswordInput from '../components/PasswordInput'

const HTML_TAG_REGEX = /<[^>]+>/
const BASIC_EMAIL_REGEX = /^[^@\s]+@[^@\s]+\.[^@\s]+$/
const sanitizeName = (raw) => {
  let v = (raw || '').replace(/\s{2,}/g, ' ').trim()
  return v
}
const sanitizeEmail = (raw) => {
  let v = (raw || '').trim().toLowerCase()
  if (v.length > 254) v = v.slice(0, 254)
  return v
}

const ProfileScreen = ({ history }) => {
  // existing basic profile states
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [username, setUsername] = useState('')
  const [email, setEmail] = useState('')
  // removed: const [message, setMessage] = useState(null)
  // password panel state
  const [showPasswordPanel, setShowPasswordPanel] = useState(false)
  const [showAddressPanel, setShowAddressPanel] = useState(false)
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmNewPassword, setConfirmNewPassword] = useState('')
  const [pwMessage, setPwMessage] = useState(null)

  // New: originals & update tracking
  const [originalFirstName, setOriginalFirstName] = useState('')
  const [originalLastName, setOriginalLastName] = useState('')
  const [originalEmail, setOriginalEmail] = useState('')
  const [successfulUpdateCount, setSuccessfulUpdateCount] = useState(0)
  const [cooldownActive, setCooldownActive] = useState(false)
  const [cooldownSeconds, setCooldownSeconds] = useState(0)
  const [profileCaptchaToken, setProfileCaptchaToken] = useState('')
  const [fieldErrors, setFieldErrors] = useState({ firstName: '', lastName: '', email: '', captcha: '' })
  const [showStepUp, setShowStepUp] = useState(false)
  const [stepUpLoading, setStepUpLoading] = useState(false)
  const [stepUpError, setStepUpError] = useState('')
  const handledSuccessRef = useRef(false)
  const cooldownTimerRef = useRef(null)
  const currentPwRef = useRef(null)

  // toast state
  const [showPwToast, setShowPwToast] = useState(false)
  const [pwToastVariant, setPwToastVariant] = useState('success')
  const [pwToastMessage, setPwToastMessage] = useState('')

  const dispatch = useDispatch()
  const { loading, error, userDetails, userInfo, success, passwordUpdateLoading, passwordUpdateError, passwordUpdateSuccess } = useSelector((state) => state.user)
  const { loading: loadingOrders, error: errorOrders, myOrders } = useSelector((state) => state.order)

  const user = userDetails

  // Derived flags
  const isDirty = firstName !== originalFirstName || lastName !== originalLastName || email !== originalEmail
  const showRecaptcha = successfulUpdateCount >= 2
  const disableUpdate = loading || !isDirty || cooldownActive || !!fieldErrors.firstName || !!fieldErrors.lastName || !!fieldErrors.email || (showRecaptcha && !profileCaptchaToken)

  // Effect A: load user & orders once / when user changes
  useEffect(() => {
    if (!userInfo) {
      history.push('/login')
      return
    }
    if (!user || !user._id) {
      dispatch(getUserDetails('profile'))
      dispatch(listMyOrders())
    } else {
      setFirstName(user.firstName || '')
      setLastName(user.lastName || '')
      setUsername(user.username || '')
      setEmail(user.email || '')
      setOriginalFirstName(user.firstName || '')
      setOriginalLastName(user.lastName || '')
      setOriginalEmail(user.email || '')
      if (typeof user.profileUpdateCount === 'number') {
        setSuccessfulUpdateCount(user.profileUpdateCount)
      }
      handledSuccessRef.current = false // reset handler readiness for this loaded snapshot
    }
  }, [dispatch, history, userInfo, user])

  // Effect B: handle successful profile update
  useEffect(() => {
    if (success && !handledSuccessRef.current) {
      handledSuccessRef.current = true
      // prefer server count from userInfo if present
      if (userInfo && typeof userInfo.profileUpdateCount === 'number') {
        setSuccessfulUpdateCount(userInfo.profileUpdateCount)
      } else {
        setSuccessfulUpdateCount((c) => c + 1)
      }
      // start cooldown
      setCooldownActive(true)
      setCooldownSeconds(10)
      if (cooldownTimerRef.current) clearInterval(cooldownTimerRef.current)
      cooldownTimerRef.current = setInterval(() => {
        setCooldownSeconds((s) => {
          if (s <= 1) {
            clearInterval(cooldownTimerRef.current)
            cooldownTimerRef.current = null
            setCooldownActive(false)
            return 0
          }
          return s - 1
        })
      }, 1000)
      // refresh details to sync normalized backend result
      dispatch(getUserDetails('profile'))
      // reset success flag in slice
      dispatch({ type: USER_UPDATE_PROFILE_RESET })
      // reset captcha token (require solving again for each attempt once captcha phase started)
      setProfileCaptchaToken('')
    }
  }, [success, dispatch, userInfo])

  // Cleanup cooldown timer on unmount
  useEffect(() => () => { if (cooldownTimerRef.current) clearInterval(cooldownTimerRef.current) }, [])

  // Password panel focus
  useEffect(() => { if (showPasswordPanel && currentPwRef.current) currentPwRef.current.focus() }, [showPasswordPanel])

  // clear password panel on password update success
  useEffect(() => { if (passwordUpdateSuccess) { setCurrentPassword(''); setNewPassword(''); setConfirmNewPassword(''); setPwMessage(null) } }, [passwordUpdateSuccess])
  useEffect(() => { if (passwordUpdateSuccess) { setPwToastVariant('success'); setPwToastMessage('Password updated'); setShowPwToast(true) } }, [passwordUpdateSuccess])
  useEffect(() => { if (passwordUpdateError) { setPwToastVariant('danger'); setPwToastMessage(passwordUpdateError); setShowPwToast(true) } }, [passwordUpdateError])

  // Field change handlers with sanitation & validation
  const handleFirstNameChange = (v) => {
    const cleaned = sanitizeName(v)
    let err = ''
    if (!cleaned) err = 'Required'
    else if (HTML_TAG_REGEX.test(cleaned)) err = 'Invalid'
    setFirstName(cleaned)
    setFieldErrors(prev => ({ ...prev, firstName: err }))
  }
  const handleLastNameChange = (v) => {
    const cleaned = sanitizeName(v)
    let err = ''
    if (!cleaned) err = 'Required'
    else if (HTML_TAG_REGEX.test(cleaned)) err = 'Invalid'
    setLastName(cleaned)
    setFieldErrors(prev => ({ ...prev, lastName: err }))
  }
  const handleEmailChange = (v) => {
    const cleaned = sanitizeEmail(v)
    let err = ''
    if (!cleaned) err = 'Required'
    else if (HTML_TAG_REGEX.test(cleaned)) err = 'Invalid'
    else if (!BASIC_EMAIL_REGEX.test(cleaned)) err = 'Invalid format'
    setEmail(cleaned)
    setFieldErrors(prev => ({ ...prev, email: err }))
  }

  const submitProfileFields = () => ({
    id: user?._id,
    firstName,
    lastName,
    email,
    ...(showRecaptcha ? { grecaptcha: profileCaptchaToken } : {}),
  })

  const submitProfileHandler = (e) => {
    e.preventDefault()
    if (disableUpdate) return
    if (showRecaptcha && !profileCaptchaToken) {
      setFieldErrors(prev => ({ ...prev, captcha: 'Captcha required' }))
      return
    }
    handledSuccessRef.current = false // allow success effect to run for this cycle
    // Changing the email is step-up-gated; other field changes are not.
    if (email !== originalEmail) {
      setStepUpError('')
      setShowStepUp(true)
    } else {
      dispatch(updateUserProfile(submitProfileFields()))
    }
  }

  const handleStepUpConfirm = async (password) => {
    setStepUpLoading(true)
    setStepUpError('')
    try {
      const stepUpToken = await requestStepUpToken(password, userInfo?.token)
      setShowStepUp(false)
      handledSuccessRef.current = false
      dispatch(updateUserProfile({ ...submitProfileFields(), stepUpToken }))
    } catch (err) {
      setStepUpError(err.message)
    } finally {
      setStepUpLoading(false)
    }
  }

  const submitPasswordHandler = (e) => {
    e.preventDefault()
    if (!currentPassword || !newPassword || !confirmNewPassword) { setPwMessage('All fields are required'); return }
    if (newPassword !== confirmNewPassword) { setPwMessage('New passwords do not match'); return }
    if (newPassword.length < 8) { setPwMessage('New password must be at least 8 characters'); return }
    setPwMessage(null)
    dispatch(updateUserPassword({ currentPassword, password: newPassword, id: user?._id }))
  }

  const togglePasswordPanel = () => {
    if (showPasswordPanel) {
      setShowPasswordPanel(false)
      setPwMessage(null)
      dispatch(resetPasswordUpdate())
    } else {
      setShowPasswordPanel(true)
      setShowAddressPanel(false)
    }
  }
  const toggleAddressPanel = () => {
    if (showAddressPanel) {
      setShowAddressPanel(false)
    } else {
      setShowAddressPanel(true)
      setShowPasswordPanel(false)
    }
  }

  return (
    <>
  <Meta title='Profile — The Lotustor' robots='noindex,follow' />
      <Row>
        <Col md={3}>
          <h2>User Profile</h2>
          <h4>Username: {username}</h4>
          {success && <Message variant='success'>Profile Updated</Message>}
          {loading ? <Loader /> : error ? <Message variant='danger'>{error}</Message> : (
            <Form onSubmit={submitProfileHandler}>
              <Form.Group controlId='firstName'>
                <Form.Label>First Name</Form.Label>
                <Form.Control type='text' value={firstName} onChange={(e) => handleFirstNameChange(e.target.value)} placeholder='Enter first name' />
                {fieldErrors.firstName && <small className='text-danger'>{fieldErrors.firstName}</small>}
              </Form.Group>
              <Form.Group controlId='lastName'>
                <Form.Label>Last Name</Form.Label>
                <Form.Control type='text' value={lastName} onChange={(e) => handleLastNameChange(e.target.value)} placeholder='Enter last name' />
                {fieldErrors.lastName && <small className='text-danger'>{fieldErrors.lastName}</small>}
              </Form.Group>
              <Form.Group controlId='email'>
                <Form.Label>Email Address</Form.Label>
                <Form.Control type='email' value={email} onChange={(e) => handleEmailChange(e.target.value)} placeholder='Enter email' />
                {fieldErrors.email && <small className='text-danger'>{fieldErrors.email}</small>}
              </Form.Group>
              {showRecaptcha && (
                <Form.Group controlId='profileCaptcha' className='mb-2'>
                  <ReCAPTCHA sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || ''} onChange={(val) => { setProfileCaptchaToken(val || ''); setFieldErrors(prev => ({ ...prev, captcha: '' })) }} />
                  {fieldErrors.captcha && <small className='text-danger'>{fieldErrors.captcha}</small>}
                </Form.Group>
              )}
              {cooldownActive && <small className='text-muted d-block mb-2'>Please wait {cooldownSeconds}s before updating again.</small>}
              <Button type='submit' variant='primary' disabled={disableUpdate}>
                {cooldownActive ? `Update (${cooldownSeconds}s)` : 'Update'}
              </Button>
            </Form>
          )}
        </Col>
        <Col md={9}>
          <div className='d-flex justify-content-between align-items-center mb-3 gap-2'>
            <h2 className='mb-0'>
              {showPasswordPanel ? 'Change Password' : showAddressPanel ? 'Manage Addresses' : 'My Orders'}
            </h2>
            <div className='d-flex gap-2'>
              <Button variant={showAddressPanel ? 'secondary' : 'outline-primary'} onClick={toggleAddressPanel} disabled={!showAddressPanel && userInfo?.isGuest}>
                {showAddressPanel ? 'Back to My Orders' : 'Manage Addresses'}
              </Button>
              <Button variant={showPasswordPanel ? 'secondary' : 'outline-primary'} onClick={togglePasswordPanel} disabled={!showPasswordPanel && userInfo?.isGuest}>
                {showPasswordPanel ? 'Back to My Orders' : 'Change Password'}
              </Button>
            </div>
          </div>
          {showAddressPanel ? (
            <div>
              {userInfo?.isGuest ? (
                <Message variant='warning'>Guest accounts cannot manage saved addresses.</Message>
              ) : (
                <AddressManager />
              )}
            </div>
          ) : !showPasswordPanel ? (
            loadingOrders ? <Loader /> : errorOrders ? <Message variant='danger'>{errorOrders}</Message> : (
              <Table striped bordered hover responsive className='table-sm'>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>DATE</th>
                    <th>TOTAL</th>
                    <th>PAID</th>
                    <th>SHIPPED</th>
                    <th>DELIVERED</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {(myOrders || []).map(order => (
                    <tr key={order._id}>
                      <td>{order._id}</td>
                      <td>{order.createdAt.substring(0, 10)}</td>
                      <td>{order.totalPrice}</td>
                      <td>{order.isPaid ? (order.paidAt.substring(0, 10)) : (<i className='fas fa-times' style={{ color: 'red' }}></i>)}</td>
                      <td>{order.isShipped ? (order.shippedAt.substring(0, 10)) : (<i className='fas fa-times' style={{ color: 'red' }}></i>)}</td>
                      <td>{order.isDelivered ? (order.deliveredAt.substring(0, 10)) : (<i className='fas fa-times' style={{ color: 'red' }}></i>)}</td>
                      <td>
                        <LinkContainer to={`/order/${order._id}`}>
                          <Button className='btn-sm' variant='light'>Details</Button>
                        </LinkContainer>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )
          ) : (
            <Form onSubmit={submitPasswordHandler} style={{ maxWidth: '480px' }}>
              {pwMessage && <Message variant='danger'>{pwMessage}</Message>}
              {passwordUpdateError && <Message variant='danger'>{passwordUpdateError}</Message>}
              {passwordUpdateSuccess && <Message variant='success'>Password Updated</Message>}
              {userInfo?.isGuest && <Message variant='warning'>Guest accounts cannot change password.</Message>}
              <PasswordInput
                id='currentPassword'
                label='Current Password'
                value={currentPassword}
                onChange={(e) => { setCurrentPassword(e.target.value); setPwMessage(null) }}
                autoComplete='current-password'
                disabled={userInfo?.isGuest}
                inputRef={currentPwRef}
              />
              <PasswordInput
                id='newPassword'
                label='New Password'
                value={newPassword}
                onChange={(e) => { setNewPassword(e.target.value); setPwMessage(null) }}
                autoComplete='new-password'
                disabled={userInfo?.isGuest}
              />
              <PasswordInput
                id='confirmNewPassword'
                label='Confirm New Password'
                value={confirmNewPassword}
                onChange={(e) => { setConfirmNewPassword(e.target.value); setPwMessage(null) }}
                autoComplete='new-password'
                disabled={userInfo?.isGuest}
              />
              <Button type='submit' variant='primary' disabled={passwordUpdateLoading || userInfo?.isGuest}>
                {passwordUpdateLoading ? 'Updating...' : 'Update Password'}
              </Button>
            </Form>
          )}
        </Col>
      </Row>
      <div aria-live='polite' aria-atomic='true' style={{ position: 'fixed', top: 12, right: 12, zIndex: 1060 }}>
        <Toast bg={pwToastVariant} onClose={() => setShowPwToast(false)} show={showPwToast} delay={3000} autohide>
          <Toast.Header closeButton>
            <strong className='me-auto'>{pwToastVariant === 'success' ? 'Success' : 'Error'}</strong>
          </Toast.Header>
          <Toast.Body className={pwToastVariant === 'danger' ? 'text-white' : ''}>{pwToastMessage}</Toast.Body>
        </Toast>
      </div>

      <StepUpPasswordModal
        show={showStepUp}
        title='Confirm email change'
        description='For your security, please re-enter your password to change your email address.'
        onCancel={() => setShowStepUp(false)}
        onConfirm={handleStepUpConfirm}
        loading={stepUpLoading}
        error={stepUpError}
      />
    </>
  )
}

export default ProfileScreen
